import r from "react";
import { cls as m } from "../../../helpers/cls.js";
const c = _ref => {
  let {
    tagOverflow: l,
    elementId: e,
    overlayMaxHeight: t,
    hasLabel: a,
    shadow: o,
    children: s
  } = _ref;
  const i = l != null ? l : "ul";
  return r.createElement(i, {
    "aria-labelledby": "ex1-label",
    "aria-live": "assertive",
    id: "".concat(e, "-autocomplete-list"),
    "data-testid": "".concat(e, "-autocomplete-list"),
    style: {
      maxHeight: t != null ? t : "500px"
    },
    className: m("olx-autocomplete__list", a && "olx-autocomplete__list--label", o && "olx-autocomplete__list--shadow", "listbox")
  }, s);
};
export { c as Overflow };